import { Loader } from '@pocketlaw/tetris';
import { motion } from 'motion/react';
export function MessageLoader(props) {
    const { show } = props;
    return (show && (<motion.div initial={{ opacity: 1 }} animate={{ opacity: show ? 1 : 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <Loader size={7}/>
      </motion.div>));
}
